/**
 * Marca no <body> quando a tela atual exibe a barra de navegação inferior
 * do módulo Minha Área (celular).
 *
 * Serve para elementos flutuantes globais (o mascote da Beaa, por exemplo)
 * saberem que precisam subir para não cobrir a barra. Usar uma marca no DOM
 * evita repetir listas de rotas em arquivos diferentes: quem renderiza a
 * barra é quem liga a marca.
 */
export const CLASSE_NAV_INFERIOR = 'tem-nav-inferior';

/** Lê a marca atual (usado para o primeiro render, antes de qualquer efeito). */
export const temNavInferiorAtiva = (): boolean =>
  typeof document !== 'undefined' && document.body.classList.contains(CLASSE_NAV_INFERIOR);